// extracted by mini-css-extract-plugin
module.exports = {"productImage":"fjLMOB","productBadge":"brBOaM","badge":"ple2j1","defaultImage":"lqACfO"};